module.exports = __webpack_public_path__ + "static/media/logo.7c254fb4.png";